<template>
  <div class="table">
    <el-row>
      <el-switch style="display: block" v-model="options" @change="optionsChange" active-color="#409EFF" inactive-color="#E7E7E7" active-text="Facility" inactive-text="供应商"></el-switch>
    </el-row>
    <el-row v-if="tags.length>0">
      <p style="padding: 5px 10px 0 10px;">已选择的{{!options?"供应商":"Facility"}}</p>
    </el-row>
    <div class="container" v-if="tags.length>0">
      <div class="handle-box">
        <div class="tag_dv">
          <div class="tag_dv_children" v-for="tag in tags" :key="tag.supplierCode" style="margin-bottom:10px">
            <el-tag closable @close="handleClose(tag)">
              {{tag.supplierName}}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="handle-box" v-if="options">
        <el-form :model="supplierForm" ref="supplierForm" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="供应商名称" prop="supplierName">
                <el-input v-model="supplierForm.supplierName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商英文名称" prop="supplierNameEn">
                <el-input v-model="supplierForm.supplierNameEn" @blur="getAslName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Facility中文名称" prop="plantName">
                <el-input v-model="supplierForm.plantName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Facility英文名称" prop="plantNameEn">
                <el-input v-model="supplierForm.plantNameEn" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <!-- 结算单位选择 -->
      <el-row class="action-btn-row" v-if="!options">
        <el-button size="small" class="btn" type="primary" @click="onSelSupplier">添加</el-button>
        <el-button size="small" class="btn" type="primary" @click="onConfirmSupplier">确认</el-button>
      </el-row>
      <!-- facility选择 -->
      <el-row class="action-btn-row" v-if="options">
        <el-button size="small" class="btn" type="primary" @click="onSelPlant">添加</el-button>
        <el-button size="small" class="btn" type="primary" @click="onConfirmPlant">确认</el-button>
      </el-row>
      <el-table v-if="!options" ref="multipleTable1" :data="supplierData" @selection-change="selectionChange1" max-height="400" border stripe highlight-current-row>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="供应商名称" min-width="100" prop="supplierName"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="供应商英文名称" min-width="90" prop="supplierNameEn"></el-table-column>
      </el-table>
      <el-table v-if="options" ref="multipleTable2" :data="facilityData" @selection-change="selectionChange2" max-height="400" border stripe highlight-current-row>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="供应商名称" min-width="100" prop="supplierName"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="供应商英文名称" min-width="90" prop="supplierNameEn"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="Facility中文名称" min-width="90" prop="plantName"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="Facility英文名称" min-width="120" prop="plantNameEn"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import rmcProdPurchaseApi from "@/api/rmcProduce/purchase";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";

export default {
  name: 'rmcProdPurchase',
  mixins: [paginationMixin],
  props: ['data'],
  components: {
    IcSelect,
  },
  data() {
    return {
      ms_Permission: [],
      supplierData: [],//供应商列表
      facilityData: [],//facility列表
      multipleSelection1: [],//供应商选中的数据
      multipleSelection2: [],//facility选中的数据
      supplierCodeLists: [],//存放供应商选中的supplierCode
      plantCodeLists: [],//存放facility选中的plantCode
      tags: [],
      supplierCode_data_list: [],//原始存在的结算单位list
      facility_data_list: [],//原始存在的facility list
      labelCloumns: [],//存放原始的表头数据
      supplierCode_data: [],//原始存在的供应商code
      facility_data: [],//原始存在的facility Code
      add_original_facility: [],//通过原始的label筛选出数据
      supplierForm: {
        pageSize: 15,
        pageNum: 1,
        supplierName: "",
        supplierNameEn: "",
        plantName: "",
        plantNameEn: "",
      },
      options: false,//false为供应商,true为facility
      totalCount: 0,
      pages: 1,
    }
  },
  watch: {
    data: {
      handler(newV, oldV) {
        console.log('获取原始表头数据', JSON.parse(newV));
        if (newV) {
          this.labelCloumns = JSON.parse(newV)
          this.labelCloumns.forEach(ele => {
            // type=2为集团,type=1是facility
            if (ele.type === 2) {
              this.supplierCode_data.push(ele.supplierCode)
              this.supplierCode_data_list.push(ele)
            }
            if (ele.type === 1) {
              this.facility_data.push(ele.supplierCode)
              this.facility_data_list.push(ele)
            }
          })
          this.tags = this.supplierCode_data_list
          console.log('labelCloumns', this.labelCloumns);
          console.log('supplierCode_data', this.supplierCode_data);
          console.log('facility_data', this.facility_data);
          console.log('supplierCode_data_list', this.supplierCode_data_list);
          console.log('facility_data_list', this.facility_data_list);
        }
      },
      immediate: true
    }
  },
  created() {
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    this.$nextTick(() => {
      this.queryData1()
      this.queryData2()
    })
  },
  methods: {
    // 获取集团列表
    queryData1() {
      rmcProdPurchaseApi.findSponsor({}).then(res => {
        console.log('获取集团列表', res);
        this.supplierData = res;
      });
    },
    // 获取facility列表
    queryData2() {
      rmcProdPurchaseApi.findFacility(this.supplierForm).then(res => {
        console.log('获取facility列表', res);
        this.facilityData = res;
      });
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    optionsChange(val) {
      console.log('val', val);
      if (val) {
        this.tags = this.facility_data_list
        this.queryData2()
      } else {
        this.tags = this.supplierCode_data_list
        this.queryData1()
      }
    },
    // 获取供应商选中的数据
    selectionChange1(val) {
      console.log('选中的数据', val);
      this.supplierCodeLists = []
      this.multipleSelection1 = val;
      val.forEach(ele => {
        this.supplierCodeLists.push({
          supplierCode: ele.supplierCode,
          supplierName: ele.supplierName,
        })
      })
    },
    // 供应商选择确认
    onSelSupplier() {
      console.log('原始数据', this.labelCloumns);
      for (let ele of this.multipleSelection1) {
        // 如果有相同的值那么就返回对应的对象 如果没有则返回 undefined
        const itemJson = this.tags.find((item) => { return item.supplierCode === ele.supplierCode });
        console.log('itemJson', itemJson)
        if (itemJson) {
          this.$message.error(itemJson.supplierName + '已存在,请勿重复添加!')
          return
        }
      }
      if (this.labelCloumns.length > 0) {
        var flag = this.labelCloumns.some(ele => {
          return ele.type === 1
        })
        if (flag) {
          this.$message.error('Sponsor ' + this.multipleSelection1[0].supplierName + '下的工厂已维护采购量,无法重复添加.')
          return false
        }
      }
      this.tags = this.tags.concat(this.multipleSelection1)
      this.$refs.multipleTable1.clearSelection();
      // this.$emit('setSupplier', JSON.stringify(this.multipleSelection1))
    },
    onConfirmSupplier() {
      console.log('tags', this.tags);
      console.log('facility_data_list', this.facility_data_list);
      var flag = false
      var length1 = this.tags.length
      var length2 = this.facility_data_list.length
      var length = Number(length1) + Number(length2)
      console.log('length1', length1);
      console.log('length2', length2);
      console.log('length', length);
      if (length > 20) {
        this.$message.error('最多选择20家供应商伙伴')
        flag = true
      }
      if (!flag) {
        this.$emit('setSupplier', JSON.stringify(this.tags))
      }
    },
    // 获取facility选中的数据
    selectionChange2(val) {
      this.multipleSelection2 = val;
    },
    onSelPlant() {
      console.log('获取选中的数据2', this.multipleSelection2);
      console.log('已经存在的supplierCode', this.supplierCode_data);
      for (let ele of this.multipleSelection2) {
        // 如果有相同的值那么就返回对应的对象 如果没有则返回 undefined
        const itemJson = this.tags.find((item) => { return item.supplierCode === ele.plantCode });
        console.log('itemJson', itemJson)
        if (itemJson) {
          this.$message.error(itemJson.supplierName + '已存在,请勿重复添加!')
          return
        }
      }
      if (this.labelCloumns.length > 0) {
        var flag = this.labelCloumns.some(ele => {
          return ele.type === 2
        })
        if (flag) {
          this.$message.error('Facility工厂对应的Sponsor已维护,无法重复添加.')
          return false
        }
      }
      if (this.multipleSelection2.length > 0) {
        var format_arr = []
        this.multipleSelection2.forEach(ele => {
          format_arr.push({
            aslName: null,
            purchaseQuantity: null,
            supplierCode: ele.plantCode,
            supplierName: ele.plantName,
            type: 1,
          })
        })
      }
      // this.$emit('setFacility', JSON.stringify(this.multipleSelection2))
      this.tags = this.tags.concat(format_arr)
      this.$refs.multipleTable2.clearSelection();
    },
    onConfirmPlant() {
      console.log('tags', this.tags);
      console.log('supplierCode_data_list', this.supplierCode_data_list);
      var flag = false
      var length1 = this.tags.length
      var length2 = this.supplierCode_data_list.length
      var length = Number(length1) + Number(length2)
      console.log('length1', length1);
      console.log('length2', length2);
      console.log('length', length);
      if (length > 20) {
        this.$message.error('最多选择20家供应商伙伴')
        flag = true
      }
      if (!flag) {
        this.$emit('setFacility', JSON.stringify(this.tags))
      }
    },
    onSearch() {
      if (!this.options) {
        this.queryData1()
      } else {
        this.queryData2()
      }
    },
    onReset() {
      this.$refs['supplierForm'].resetFields()
      this.supplierForm = {
        pageSize: 15,
        pageNum: 1,
        supplierName: "",
        supplierNameEn: "",
        plantName: "",
        plantNameEn: "",
      }
      if (!this.options) {
        this.queryData1()
      } else {
        this.queryData2()
      }
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
